import { render } from "./AboutBox.vue?vue&type=template&id=74dcce8b&scoped=true&lang=pug"
import script from "./AboutBox.vue?vue&type=script&lang=js"
export * from "./AboutBox.vue?vue&type=script&lang=js"

import "./AboutBox.vue?vue&type=style&index=0&id=74dcce8b&lang=sass&scoped=true"

import exportComponent from "C:\\Users\\User\\Desktop\\nxin_0501\\nxin_vue\\前台程式\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74dcce8b"]])

export default __exports__